<script setup>
const benefits = [
  'Build a full SEO strategy — including keyword targeting, blog topics, and tone-of-voice playbook',
  'Optimise 3 website pages each month (covering copy, metadata, and tech SEO)',
  'Write 1 SEO-friendly blog post per month',
  'Optimise the Google Business Profile listing — including weekly Google Posts, FAQs, and listing updates',
  'Manage Google reviews — including responding to reviews (with approval)',
  'Build local citation listings via Uberall',
  'Send weekly updates with completed tasks and actions requiring approval',
  'Deliver a full monthly SEO performance report',
];
</script>

<template>
  <div class="tw-flex tw-flex-col tw-gap-6 tw-text-base tw-text-neutral-900">
    <div
      v-for="(benefit, key) in benefits"
      :key="key"
      class="tw-flex tw-gap-4"
    >
      <div class="tw-my-2 tw-ml-2 tw-mr-1 tw-text-primary">
        <SvgVue
          icon="icons/check"
          class="tw-h-2 tw-w-2"
        />
      </div>
      <span class="tw-text-left">
        {{ benefit }}
      </span>
    </div>
  </div>
</template>
